module.exports = __webpack_public_path__ + "static/img/11.9721c8e7.png";